<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            Choose an accordion from the list below.  When configuring the accordion for use in the tile component.   Each "section" will become a 
            tile.  The front of the tile will be generated from the odd sequenced details and back will be generated from the even sequences.  
            The tile will handle images (media properties) and text.   All other media properties will be ignored at this time.<br /><br />
            For audio, any audio that should play before the tiles flip should be set at the parent accordion/object level.   Any audio that 
            should play on flip, should be set in the accordion assigned to the medial property.
        </div>
        <div class="formRow">
            <h4>Change Tile On:</h4>
            <select v-model="$parent.mediaProperty.configuration.changeAction" @change="save" :disabled="!allowEdit">
                <option value=""></option>
                <option v-for="record in changeActionTypes" :key="record.value" :value="record.internalName">{{record.displayName}}</option>
            </select>
        </div>
        <div class="formRow">
            <h4>Accordion:</h4>
            <div> {{ accordionCode }}</div>
            <AddAccordionModal v-if="loading===false" :isActive="true" :onAccordionSave="save" :showDelete="false" :accordionCode="accordionCode"></AddAccordionModal>
        </div>
    </div>
</template>

<script>
import { data } from '../../shared/data';
import AddAccordionModal from '@/components/accordion/AddAccordionModal.vue';


export default {
    name: 'HtmlTileEdit',
    components: { AddAccordionModal },
    data() {
        return {
            changeActionTypes: [],
            accordionCode: '',
            loading: true
        }
    },
    props: {
        input_configuration: {
            type: Object
        },
        allowEdit: {
            type: Boolean,
            required: true
        }
    },        
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            return (
                configuration.changeAction != '' &&
                configuration.tileDataID != null
            )
        },
    },
    async mounted() {
        this.changeActionTypes = await data. getEnumList('TileChangeActions', false);
        this.changeActionTypes.sort((a,b) => {
            if (a.code > b.code) return 1;
            if (a.code < b.code) return -1;
            return 0;
        });

        this.loading = true;

        if(this.$parent.mediaProperty) {
            if(!this.$parent.mediaProperty.configuration) {
                this.$parent.mediaProperty.configuration = {
                    changeAction: '',
                    tileDataID: null
                }
            }

            if(this.$parent.mediaProperty.configuration.tileDataID)
                data.getAccordion(this.$parent.mediaProperty.configuration.tileDataID)
                    .then((object) => {this.accordionCode = object.code; this.loading = false; });
            else 
                this.loading = false;
        }
    },
    methods: {
        save: async function(accordionCode, accordion) {
            if(accordion) {
                this.$parent.mediaProperty.configuration.tileDataID = accordion.id;
                this.accordionCode = accordionCode;
            }

            if(this.validated) {
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
            }
            else
                this.$toast.error('All fields are required');
        }
    }
}
</script>